// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kffPz","location":"styles_location__IG1NG","circle":"styles_circle__Bc8HJ","placement":"styles_placement__b0BaF","slice":"styles_slice__SVA90"};